import { Illustrations } from './illustration.model';

export const availableIllustrations: { [key: string]: string[] } = {
    asn: [
        Illustrations.AANMELDEN,
        Illustrations.AANMELDENMOBIEL,
        Illustrations.AANMELDENSUCCES,
        Illustrations.ADVIESKEUZE,
        Illustrations.AFMRISKSCORE1,
        Illustrations.AFMRISKSCORE2,
        Illustrations.AFMRISKSCORE3,
        Illustrations.AFMRISKSCORE4,
        Illustrations.AFMRISKSCORE5,
        Illustrations.AFMRISKSCORE6,
        Illustrations.ANNUITEITEN,
        Illustrations.ASNMISSIE,
        Illustrations.AVATAR,
        Illustrations.AVATARAGENT,
        Illustrations.AVATARAGENTDARK,
        Illustrations.AVATARBOT,
        Illustrations.AVATARBOTDARK,
        Illustrations.BELEGGENDOEL,
        Illustrations.BELEGGENGROEI,
        Illustrations.BETA,
        Illustrations.BETAALPAS,
        Illustrations.BETAALPASJUNIOR,
        Illustrations.BETAALPAS2,
        Illustrations.BETALENSUCCES,
        Illustrations.BIODIVERSITY,
        Illustrations.CHAT,
        Illustrations.CODEPOSTSMSEMAIL,
        Illustrations.CODESMSEMAIL,
        Illustrations.DEBITCARD,
        Illustrations.DEBITCARDYOUTH,
        Illustrations.DIGIPASBACK,
        Illustrations.DIGIPASFRONT,
        Illustrations.DOORGAAN,
        Illustrations.EMPTY,
        Illustrations.EMPTYSTATE,
        Illustrations.ENERGYLABELA,
        Illustrations.ENERGYLABELAP_APP,
        Illustrations.ENERGYLABELAPP,
        Illustrations.ENERGYLABELAPPP,
        Illustrations.ENERGYLABELAPPPP,
        Illustrations.ENERGYLABELAPPPP10YR,
        Illustrations.ENERGYLABELB,
        Illustrations.ENERGYLABELC_D,
        Illustrations.ENERGYLABELE_F_G,
        Illustrations.EPPO,
        Illustrations.ERROR,
        Illustrations.EVENGEDULD,
        Illustrations.EVENGEDULD2,
        Illustrations.FACEID,
        Illustrations.FACEIDVINGERAFDRUK,
        Illustrations.FEEDBACK,
        Illustrations.GEMACHTIGDE,
        Illustrations.GEMACHTIGDENOBG,
        Illustrations.GEPLAND,
        Illustrations.HOUSE,
        Illustrations.HYPOTHEKENHUISJE,
        Illustrations.HYPOTHEKENHUISJEDARK,
        Illustrations.HYPOTHEKENSTAP1,
        Illustrations.HYPOTHEKENSTAP1DARK,
        Illustrations.HYPOTHEKENSTAP2,
        Illustrations.HYPOTHEKENSTAP2DARK,
        Illustrations.HYPOTHEKENSTAP3,
        Illustrations.HYPOTHEKENSTAP3DARK,
        Illustrations.IDENTIFICEREN,
        Illustrations.IDENTITEITSBEWIJS,
        Illustrations.KIND,
        Illustrations.KINDNOBG,
        Illustrations.KLAAR,
        Illustrations.LINEAIR,
        Illustrations.LOGOASN,
        Illustrations.LOGOASNDARK,
        Illustrations.LOGOBLG,
        Illustrations.LOGOBLGDARK,
        Illustrations.LOGOREB,
        Illustrations.LOGOREBDARK,
        Illustrations.LOGOSNS,
        Illustrations.LOGOSNSDARK,
        Illustrations.MICROKREDIET,
        Illustrations.PRODUCTBELEGGEN,
        Illustrations.PRODUCTBETALEN,
        Illustrations.PRODUCTHYPOTHEKEN,
        Illustrations.PRODUCTLENEN,
        Illustrations.PRODUCTOVERIG,
        Illustrations.PRODUCTPENSIOEN,
        Illustrations.PRODUCTSPAREN,
        Illustrations.PRODUCTVERZEKEREN,
        Illustrations.PUSHNOTIFICATIE,
        Illustrations.SALDOGRAFIEK,
        Illustrations.SAMEN,
        Illustrations.SAMENNOBG,
        Illustrations.THUISGESTUURD,
        Illustrations.UZELF,
        Illustrations.UZELFNOBG,
        Illustrations.VERDERINAPP,
        Illustrations.VINGERAFDRUK,
        Illustrations.VIRTUELEPAS,
        Illustrations.VOLKSBANK,
        Illustrations.VOLKSBANKDARK,
        Illustrations.WEEGSCHAAL,
        Illustrations.WELKOM,
        Illustrations.WELKOMTERUG
    ],
    blg: [
        Illustrations.AANMELDEN,
        Illustrations.AANMELDENMOBIEL,
        Illustrations.AANMELDENSUCCES,
        Illustrations.ADVIESKEUZE,
        Illustrations.AFMRISKSCORE1,
        Illustrations.AFMRISKSCORE2,
        Illustrations.AFMRISKSCORE3,
        Illustrations.AFMRISKSCORE4,
        Illustrations.AFMRISKSCORE5,
        Illustrations.AFMRISKSCORE6,
        Illustrations.ANNUITEITEN,
        Illustrations.ASNMISSIE,
        Illustrations.AVATAR,
        Illustrations.AVATARAGENT,
        Illustrations.AVATARAGENTDARK,
        Illustrations.AVATARBOT,
        Illustrations.AVATARBOTDARK,
        Illustrations.BELEGGENDOEL,
        Illustrations.BELEGGENGROEI,
        Illustrations.BETA,
        Illustrations.BETAALPAS,
        Illustrations.BETAALPASJUNIOR,
        Illustrations.BETAALPAS2,
        Illustrations.BETALENSUCCES,
        Illustrations.BIODIVERSITY,
        Illustrations.CHAT,
        Illustrations.CODEPOSTSMSEMAIL,
        Illustrations.CODESMSEMAIL,
        Illustrations.DEBITCARD,
        Illustrations.DEBITCARDYOUTH,
        Illustrations.DIGIPASBACK,
        Illustrations.DIGIPASFRONT,
        Illustrations.DOORGAAN,
        Illustrations.EMPTY,
        Illustrations.EMPTYSTATE,
        Illustrations.ENERGYLABELA,
        Illustrations.ENERGYLABELAP_APP,
        Illustrations.ENERGYLABELAPP,
        Illustrations.ENERGYLABELAPPP,
        Illustrations.ENERGYLABELAPPPP,
        Illustrations.ENERGYLABELAPPPP10YR,
        Illustrations.ENERGYLABELB,
        Illustrations.ENERGYLABELC_D,
        Illustrations.ENERGYLABELE_F_G,
        Illustrations.EPPO,
        Illustrations.ERROR,
        Illustrations.EVENGEDULD,
        Illustrations.EVENGEDULD2,
        Illustrations.FACEID,
        Illustrations.FACEIDVINGERAFDRUK,
        Illustrations.FEEDBACK,
        Illustrations.GEMACHTIGDE,
        Illustrations.GEMACHTIGDENOBG,
        Illustrations.GEPLAND,
        Illustrations.HOUSE,
        Illustrations.HYPOTHEKENHUISJE,
        Illustrations.HYPOTHEKENHUISJEDARK,
        Illustrations.HYPOTHEKENSTAP1,
        Illustrations.HYPOTHEKENSTAP1DARK,
        Illustrations.HYPOTHEKENSTAP2,
        Illustrations.HYPOTHEKENSTAP2DARK,
        Illustrations.HYPOTHEKENSTAP3,
        Illustrations.HYPOTHEKENSTAP3DARK,
        Illustrations.IDENTIFICEREN,
        Illustrations.IDENTITEITSBEWIJS,
        Illustrations.KIND,
        Illustrations.KINDNOBG,
        Illustrations.KLAAR,
        Illustrations.LINEAIR,
        Illustrations.LOGOASN,
        Illustrations.LOGOASNDARK,
        Illustrations.LOGOBLG,
        Illustrations.LOGOBLGDARK,
        Illustrations.LOGOREB,
        Illustrations.LOGOREBDARK,
        Illustrations.LOGOSNS,
        Illustrations.LOGOSNSDARK,
        Illustrations.MICROKREDIET,
        Illustrations.PRODUCTBELEGGEN,
        Illustrations.PRODUCTBETALEN,
        Illustrations.PRODUCTHYPOTHEKEN,
        Illustrations.PRODUCTLENEN,
        Illustrations.PRODUCTOVERIG,
        Illustrations.PRODUCTPENSIOEN,
        Illustrations.PRODUCTSPAREN,
        Illustrations.PRODUCTVERZEKEREN,
        Illustrations.PUSHNOTIFICATIE,
        Illustrations.SALDOGRAFIEK,
        Illustrations.SAMEN,
        Illustrations.SAMENNOBG,
        Illustrations.THUISGESTUURD,
        Illustrations.UZELF,
        Illustrations.UZELFNOBG,
        Illustrations.VERDERINAPP,
        Illustrations.VINGERAFDRUK,
        Illustrations.VIRTUELEPAS,
        Illustrations.VOLKSBANK,
        Illustrations.VOLKSBANKDARK,
        Illustrations.WEEGSCHAAL,
        Illustrations.WELKOM,
        Illustrations.WELKOMTERUG
    ],
    reb: [
        Illustrations.AANMELDEN,
        Illustrations.AANMELDENMOBIEL,
        Illustrations.AANMELDENSUCCES,
        Illustrations.ADVIESKEUZE,
        Illustrations.AFMRISKSCORE1,
        Illustrations.AFMRISKSCORE2,
        Illustrations.AFMRISKSCORE3,
        Illustrations.AFMRISKSCORE4,
        Illustrations.AFMRISKSCORE5,
        Illustrations.AFMRISKSCORE6,
        Illustrations.ANNUITEITEN,
        Illustrations.ASNMISSIE,
        Illustrations.AVATAR,
        Illustrations.AVATARAGENT,
        Illustrations.AVATARAGENTDARK,
        Illustrations.AVATARBOT,
        Illustrations.AVATARBOTDARK,
        Illustrations.BELEGGENDOEL,
        Illustrations.BELEGGENGROEI,
        Illustrations.BETA,
        Illustrations.BETAALPAS,
        Illustrations.BETAALPASJUNIOR,
        Illustrations.BETAALPAS2,
        Illustrations.BETALENSUCCES,
        Illustrations.BIODIVERSITY,
        Illustrations.CHAT,
        Illustrations.CODEPOSTSMSEMAIL,
        Illustrations.CODESMSEMAIL,
        Illustrations.DEBITCARD,
        Illustrations.DEBITCARDYOUTH,
        Illustrations.DIGIPASBACK,
        Illustrations.DIGIPASFRONT,
        Illustrations.DOORGAAN,
        Illustrations.EMPTY,
        Illustrations.EMPTYSTATE,
        Illustrations.ENERGYLABELA,
        Illustrations.ENERGYLABELAP_APP,
        Illustrations.ENERGYLABELAPP,
        Illustrations.ENERGYLABELAPPP,
        Illustrations.ENERGYLABELAPPPP,
        Illustrations.ENERGYLABELAPPPP10YR,
        Illustrations.ENERGYLABELB,
        Illustrations.ENERGYLABELC_D,
        Illustrations.ENERGYLABELE_F_G,
        Illustrations.EPPO,
        Illustrations.ERROR,
        Illustrations.EVENGEDULD,
        Illustrations.EVENGEDULD2,
        Illustrations.FACEID,
        Illustrations.FACEIDVINGERAFDRUK,
        Illustrations.FEEDBACK,
        Illustrations.GEMACHTIGDE,
        Illustrations.GEMACHTIGDENOBG,
        Illustrations.GEPLAND,
        Illustrations.HOUSE,
        Illustrations.HYPOTHEKENHUISJE,
        Illustrations.HYPOTHEKENHUISJEDARK,
        Illustrations.HYPOTHEKENSTAP1,
        Illustrations.HYPOTHEKENSTAP1DARK,
        Illustrations.HYPOTHEKENSTAP2,
        Illustrations.HYPOTHEKENSTAP2DARK,
        Illustrations.HYPOTHEKENSTAP3,
        Illustrations.HYPOTHEKENSTAP3DARK,
        Illustrations.IDENTIFICEREN,
        Illustrations.IDENTITEITSBEWIJS,
        Illustrations.KIND,
        Illustrations.KINDNOBG,
        Illustrations.KLAAR,
        Illustrations.LINEAIR,
        Illustrations.LOGOASN,
        Illustrations.LOGOASNDARK,
        Illustrations.LOGOBLG,
        Illustrations.LOGOBLGDARK,
        Illustrations.LOGOREB,
        Illustrations.LOGOREBDARK,
        Illustrations.LOGOSNS,
        Illustrations.LOGOSNSDARK,
        Illustrations.MICROKREDIET,
        Illustrations.PRODUCTBELEGGEN,
        Illustrations.PRODUCTBETALEN,
        Illustrations.PRODUCTHYPOTHEKEN,
        Illustrations.PRODUCTLENEN,
        Illustrations.PRODUCTOVERIG,
        Illustrations.PRODUCTPENSIOEN,
        Illustrations.PRODUCTSPAREN,
        Illustrations.PRODUCTVERZEKEREN,
        Illustrations.PUSHNOTIFICATIE,
        Illustrations.SALDOGRAFIEK,
        Illustrations.SAMEN,
        Illustrations.SAMENNOBG,
        Illustrations.THUISGESTUURD,
        Illustrations.UZELF,
        Illustrations.UZELFNOBG,
        Illustrations.VERDERINAPP,
        Illustrations.VINGERAFDRUK,
        Illustrations.VIRTUELEPAS,
        Illustrations.VOLKSBANK,
        Illustrations.VOLKSBANKDARK,
        Illustrations.WEEGSCHAAL,
        Illustrations.WELKOM,
        Illustrations.WELKOMTERUG
    ],
    sns: [
        Illustrations.AANMELDEN,
        Illustrations.AANMELDENMOBIEL,
        Illustrations.AANMELDENSUCCES,
        Illustrations.ADVIESKEUZE,
        Illustrations.AFMRISKSCORE1,
        Illustrations.AFMRISKSCORE2,
        Illustrations.AFMRISKSCORE3,
        Illustrations.AFMRISKSCORE4,
        Illustrations.AFMRISKSCORE5,
        Illustrations.AFMRISKSCORE6,
        Illustrations.ANNUITEITEN,
        Illustrations.ASNMISSIE,
        Illustrations.AVATAR,
        Illustrations.AVATARAGENT,
        Illustrations.AVATARAGENTDARK,
        Illustrations.AVATARBOT,
        Illustrations.AVATARBOTDARK,
        Illustrations.BELEGGENDOEL,
        Illustrations.BELEGGENGROEI,
        Illustrations.BETA,
        Illustrations.BETAALPAS,
        Illustrations.BETAALPASJUNIOR,
        Illustrations.BETAALPAS2,
        Illustrations.BETALENSUCCES,
        Illustrations.BIODIVERSITY,
        Illustrations.CHAT,
        Illustrations.CODEPOSTSMSEMAIL,
        Illustrations.CODESMSEMAIL,
        Illustrations.DEBITCARD,
        Illustrations.DEBITCARDYOUTH,
        Illustrations.DIGIPASBACK,
        Illustrations.DIGIPASFRONT,
        Illustrations.DOORGAAN,
        Illustrations.EMPTY,
        Illustrations.EMPTYSTATE,
        Illustrations.ENERGYLABELA,
        Illustrations.ENERGYLABELAP_APP,
        Illustrations.ENERGYLABELAPP,
        Illustrations.ENERGYLABELAPPP,
        Illustrations.ENERGYLABELAPPPP,
        Illustrations.ENERGYLABELAPPPP10YR,
        Illustrations.ENERGYLABELB,
        Illustrations.ENERGYLABELC_D,
        Illustrations.ENERGYLABELE_F_G,
        Illustrations.EPPO,
        Illustrations.ERROR,
        Illustrations.EVENGEDULD,
        Illustrations.EVENGEDULD2,
        Illustrations.FACEID,
        Illustrations.FACEIDVINGERAFDRUK,
        Illustrations.FEEDBACK,
        Illustrations.GEMACHTIGDE,
        Illustrations.GEMACHTIGDENOBG,
        Illustrations.GEPLAND,
        Illustrations.HOUSE,
        Illustrations.HYPOTHEKENHUISJE,
        Illustrations.HYPOTHEKENHUISJEDARK,
        Illustrations.HYPOTHEKENSTAP1,
        Illustrations.HYPOTHEKENSTAP1DARK,
        Illustrations.HYPOTHEKENSTAP2,
        Illustrations.HYPOTHEKENSTAP2DARK,
        Illustrations.HYPOTHEKENSTAP3,
        Illustrations.HYPOTHEKENSTAP3DARK,
        Illustrations.IDENTIFICEREN,
        Illustrations.IDENTITEITSBEWIJS,
        Illustrations.KIND,
        Illustrations.KINDNOBG,
        Illustrations.KLAAR,
        Illustrations.LINEAIR,
        Illustrations.LOGOASN,
        Illustrations.LOGOASNDARK,
        Illustrations.LOGOBLG,
        Illustrations.LOGOBLGDARK,
        Illustrations.LOGOREB,
        Illustrations.LOGOREBDARK,
        Illustrations.LOGOSNS,
        Illustrations.LOGOSNSDARK,
        Illustrations.MICROKREDIET,
        Illustrations.PRODUCTBELEGGEN,
        Illustrations.PRODUCTBETALEN,
        Illustrations.PRODUCTHYPOTHEKEN,
        Illustrations.PRODUCTLENEN,
        Illustrations.PRODUCTOVERIG,
        Illustrations.PRODUCTPENSIOEN,
        Illustrations.PRODUCTSPAREN,
        Illustrations.PRODUCTVERZEKEREN,
        Illustrations.PUSHNOTIFICATIE,
        Illustrations.SALDOGRAFIEK,
        Illustrations.SAMEN,
        Illustrations.SAMENNOBG,
        Illustrations.THUISGESTUURD,
        Illustrations.UZELF,
        Illustrations.UZELFNOBG,
        Illustrations.VERDERINAPP,
        Illustrations.VINGERAFDRUK,
        Illustrations.VIRTUELEPAS,
        Illustrations.VOLKSBANK,
        Illustrations.VOLKSBANKDARK,
        Illustrations.WEEGSCHAAL,
        Illustrations.WELKOM,
        Illustrations.WELKOMTERUG
    ]
};
